import { render, staticRenderFns } from "./goods-pinlei-dialog.vue?vue&type=template&id=689af0ee&scoped=true"
import script from "./goods-pinlei-dialog.vue?vue&type=script&lang=js"
export * from "./goods-pinlei-dialog.vue?vue&type=script&lang=js"
import style0 from "./goods-pinlei-dialog.vue?vue&type=style&index=0&id=689af0ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689af0ee",
  null
  
)

export default component.exports